<script setup>
  defineEmits(['input:change']);

  const model = defineModel();

  const props = defineProps({
    attributes: {
      type: Object,
      required: false
    },  
    modelValue: {
      type: [String, Number, Array, Object],
      required: false
    }
  });
</script>

<template>
  <input
    @change="$emit('input:change', $event)"
    :type="props.attributes.inputType"
    :id="props.attributes.id" 
    :name="props.attributes.name"
    :value="props.attributes.value"
    :disabled="props.attributes.disabled"
    v-model="model"
    class="jwx-hidden-control"
  />
</template>